import { useMemo } from 'react';

import { type InfiniteData, useQueryClient } from '@tanstack/react-query';

import { useWishlistsData } from '@pkg/hooks';
import { getPagesContent } from '@pkg/hooks/deprecated';

import { type IWishlist, type PaginatedResult } from '@app/client/common/structs';
import { WISHLISTS_DATA } from '@app/client/resources/wishlists';

// Because BE no longer returns `is_follower`
export function useCheckFollowedWishlists() {
    const checkAllLimit = 100;
    const followingPathQuery = { public: true, following: true };
    const followingCache = ['following=true', 'public=true', WISHLISTS_DATA, 'lists', checkAllLimit];

    const queryClient = useQueryClient();
    const followingQueryData = queryClient.getQueryData(followingCache) as InfiniteData<PaginatedResult<IWishlist>>;
    const { data } = useWishlistsData(followingPathQuery, !!followingQueryData, checkAllLimit);

    return useMemo(() => {
        const wishlistQueryData = followingQueryData || data;
        const followingWishlists = getPagesContent(wishlistQueryData?.pages) || [];
        return followingWishlists.map((wl) => wl?.slug);
    }, [data, followingQueryData]);
}
